import { array, boolean, object, string } from 'yup';
export const ONBOARDING_VALUES = {
  firstName: '',
  lastName: '',
  companyName: '',
  taxIdNumber: '',
  primaryEmail: '',
  secondaryEmails: [],
  acceptTermsAndConditions: false
};
const NO_SPECIAL_CHARACTERS = /^[\d A-Za-z-]+$/;
const COMPANY_NAME_REGEX = /^[\d ',./A-Za-z-]+$/;
const NO_SPECIAL_CHARACTERS_COMMAS_APOSTROPHES = /^[\d ',A-Za-z-]+$/;
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const trimToUndefined = value => {
  if (typeof value !== 'string') return value;
  const trimmed = value.trim();
  return trimmed === '' ? undefined : trimmed;
};
const optionalString = string().transform(trimToUndefined);
const requiredString = string().transform(value => typeof value === 'string' ? value.trim() : value);
export const validationSchema = object().shape({
  firstName: requiredString.required('Field is required').max(50, 'Maximum 50 characters').matches(NO_SPECIAL_CHARACTERS_COMMAS_APOSTROPHES, 'No special characters allowed'),
  lastName: requiredString.required('Field is required').max(50, 'Maximum 50 characters').matches(NO_SPECIAL_CHARACTERS_COMMAS_APOSTROPHES, 'No special characters allowed'),
  companyName: requiredString.required('Field is required').max(50, 'Maximum 50 characters').matches(COMPANY_NAME_REGEX, 'Invalid characters in company name'),
  taxIdNumber: optionalString.max(50, 'Maximum 50 characters').matches(NO_SPECIAL_CHARACTERS, 'No special characters allowed'),
  primaryEmail: requiredString.required('Field is required').matches(EMAIL_REGEX, 'Invalid email address'),
  secondaryEmails: array().of(requiredString.required('Field is required or must be deleted').matches(EMAIL_REGEX, 'Invalid email address')).max(10),
  acceptTermsAndConditions: boolean().oneOf([true], 'Field is required')
});
export const createOnboardingRequest = ({
  formValues
}) => {
  const {
    firstName,
    lastName,
    companyName,
    taxIdNumber,
    primaryEmail,
    secondaryEmails = [],
    acceptTermsAndConditions
  } = formValues;
  const filteredSecondaryEmails = secondaryEmails.filter(email => typeof email === 'string' && email.trim() !== '');
  return {
    firstName,
    lastName,
    companyName,
    taxIdNumber,
    primaryEmail,
    ...(filteredSecondaryEmails.length > 0 ? {
      secondaryEmails: filteredSecondaryEmails
    } : {}),
    acceptTermsAndConditions
  };
};